export default __webpack_public_path__ + "static/foret-vierge-22eff0c07d66332c82f5598f75e2ce79.png";